import { jsx } from "react/jsx-runtime";
import { IconError } from "@bynder/icons";
import { Group } from "./Group.js";
import { HelperText } from "./HelperText.js";
import { Label } from "./Label.js";
import { Row } from "./Row.js";
import { InputRow } from "./InputRow.js";
function Form({
  children,
  onSubmit,
  ...props
}) {
  return /* @__PURE__ */ jsx("form", {
    onSubmit,
    ...props,
    children
  });
}
Form.Group = Group;
Form.HelperText = HelperText;
Form.Label = Label;
Form.Row = Row;
Form.InputRow = InputRow;
Form.IconError = IconError;
export {
  Form
};
//# sourceMappingURL=Form.js.map
